import '../styles/Waiting.scss';
import waitImage from '../assets/images/riize/waitRiize.png';
import backImage from '../assets/images/common/back.png';

const WaitingRiize = () => {
  return (
    <div className="waiting-container">
      <div className="waiting-background">
        <div className="image-wrapper">
          <div className="image-container">
            <img
              src={waitImage}
              alt="Waiting background"
              className="waiting-bg-image"
            />
            <button
              className="back-button"
              onClick={() => window.history.back()}
            >
              <img src={backImage} alt="Back" className="back-image" />
            </button>
            <div className="waiting-bottom-section">
              <div className="opening-date">
                <span>3월 30일 오픈 예정</span>
              </div>
              <p className="code-instruction">
                3D INTERACTIVE CHARACTER CARD의 코드를 준비해주세요.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WaitingRiize;
